// extracted by mini-css-extract-plugin
export default {"toolTipBox":"_0aYKV0G1--ToolTipBox_toolTipBox__4ZWbj","wiggle":"_0aYKV0G1--ToolTipBox_wiggle__nbunC","shimmer":"_0aYKV0G1--ToolTipBox_shimmer__H0gVg"};